import BaseApi from "@/api/baseApi";

export default {
  fetch(storageIds) {
    return BaseApi.post('/api-piglet/api/payment-slip/v1', storageIds);
  },
  fetchNumbers(form) {
    return BaseApi.post('/api-piglet/api/payment-slip/v1/numbers', form);
  }
}
